let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hxdmX")).then(() => parcelRequire('bewlx'));